@if (count() > 0) {
<div #container class="bulk-action-bar-container">
  <div #toolbar class="bulk-action-bar" role="toolbar"
    aria-label="Aktionen für ausgewählte Einträge" i18n-aria-label="@@bulk-bar-actions">
    <ng-container [ngTemplateOutlet]="contents" [ngTemplateOutletContext]="{ $implicit: false }" />
  </div>
  <!-- Intrinsic widths remain measurable even when their actions are in the menu. -->
  <div class="bulk-action-bar-measurement-clip" aria-hidden="true" inert>
    <div #measurement class="bulk-action-bar bulk-action-bar-measurement">
      <ng-container [ngTemplateOutlet]="contents" [ngTemplateOutletContext]="{ $implicit: true }" />
    </div>
  </div>
</div>
<p-menu #menu [id]="menuId" [model]="menuItems()" [popup]="true" appendTo="body"
  [baseZIndex]="1000" [style]="{ 'max-width': 'calc(100vw - 2rem)' }"
  [dt]="{ item: { padding: '.75rem 1rem' } }"
  ariaLabel="Weitere Aktionen" i18n-ariaLabel="@@bulk-more-actions"
  (onShow)="menuOpen.set(true)" (onHide)="menuOpen.set(false)" />
<div class="bulk-action-bar-spacer" aria-hidden="true"></div>

<ng-template #contents let-measuring>
  <span class="bulk-action-bar-count" [attr.aria-live]="measuring ? null : 'polite'"
    i18n="@@bulk-bar-selected">{{ count() }} ausgewählt</span>
  @for (action of measuring ? availableActions() : visibleActions(); track action.id) {
    <span class="bulk-action-bar-item" [attr.data-action-id]="action.id">
      <p-button [text]="true" severity="secondary" [label]="action.label" [icon]="action.icon"
        [disabled]="busy() || !!action.disabled" (onClick)="runAction(action.id)" />
    </span>
  }
  @if (measuring || overflowActions().length > 0) {
    <span class="bulk-action-bar-item" data-overflow>
      <p-button [text]="true" severity="secondary" styleClass="bulk-action-bar-icon" icon="ri-more-2-fill"
        ariaLabel="Weitere Aktionen" i18n-ariaLabel="@@bulk-more-actions"
        [pt]="{ root: { 'aria-haspopup': 'menu', 'aria-controls': measuring ? undefined : menuId,
          'aria-expanded': !measuring && menuOpen() } }" (onClick)="menu.toggle($event)" />
    </span>
  }
  <span class="bulk-action-bar-item" data-clear>
    <p-button [text]="true" severity="secondary" styleClass="bulk-action-bar-icon" icon="ri-close-line"
      ariaLabel="Auswahl aufheben" i18n-ariaLabel="@@bulk-deselect"
      [disabled]="busy()" (onClick)="clearSelection()" />
  </span>
</ng-template>
}
